export const INTRODUCE = `KMG는 엔터테인먼트 비즈니스의 새로운 패러다임을 제시하는 토탈 엔터테인먼트 입니다. 
KOREA MANAGEMENT GROUP 이라는 이름에 걸맞게 잠재력 있는 참신한 인재를 발굴, 
체계적이고 전문화된 시스템으로 우수한 아티스트로 성장시켜 아시아는 물론 세계시장을 목표로 
수준 높은 컨텐츠 제작, 글로벌 시대에 발 맞추어 나가는 엔터테인먼트가 되겠습니다.`;

export const INTRODUCE_MOBILE = `KMG는 엔터테인먼트 비즈니스의 새로운 패러다임을 제시하는 토탈 엔터테인먼트 입니다. KOREA MANAGEMENT GROUP 이라는 이름에 걸맞게 잠재력 있는 참신한 인재를 발굴, 체계적이고 전문화된 시스템으로 우수한 아티스트로 성장시켜 아시아는 물론 세계시장을 목표로 수준 높은 컨텐츠 제작, 글로벌 시대에 발 맞추어 나가는 엔터테인먼트가 되겠습니다.`;
